module.exports = __webpack_public_path__ + "static/media/log_3.88bf997a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/log_3.jpg
// module id = 1892
// module chunks = 0